// Multi-up lookbook carousel. One slide per arrow step on mobile, one page
// (as many slides as fit) per step on desktop, matching what is on screen.
class LookbookCarousel extends HTMLElement {
  connectedCallback() {
    this.viewport = this.querySelector('.lookbook__viewport');
    this.slides = [...this.querySelectorAll('.lookbook__slide')];
    this.prev = this.querySelector('[data-lookbook-prev]');
    this.next = this.querySelector('[data-lookbook-next]');
    this.counter = this.querySelector('[data-lookbook-counter]');
    if (!this.viewport || !this.slides.length) return;

    this.prev?.addEventListener('click', () => this.step(-1));
    this.next?.addEventListener('click', () => this.step(1));
    this.viewport.addEventListener('scroll', () => this.sync(), { passive: true });
    window.addEventListener('resize', () => this.sync(), { passive: true });

    this.sync();
  }

  // Distance to the next slide, which is the natural paging unit here.
  stepSize() {
    if (this.slides.length < 2) return this.viewport.clientWidth;
    const a = this.slides[0].getBoundingClientRect();
    const b = this.slides[1].getBoundingClientRect();
    return b.left - a.left || this.viewport.clientWidth;
  }

  step(dir) {
    this.viewport.scrollBy({ left: dir * this.stepSize(), behavior: 'smooth' });
  }

  sync() {
    const step = this.stepSize();
    const index = Math.round(this.viewport.scrollLeft / step);
    const clamped = Math.min(Math.max(index, 0), this.slides.length - 1);

    if (this.counter) {
      this.counter.textContent = `${clamped + 1} / ${this.slides.length}`;
    }

    // Arrows are a nudge, not a pager, so they disable only at the ends.
    const max = this.viewport.scrollWidth - this.viewport.clientWidth;
    if (this.prev) this.prev.disabled = this.viewport.scrollLeft <= 1;
    if (this.next) this.next.disabled = this.viewport.scrollLeft >= max - 1;

    this.slides.forEach((slide, i) => {
      slide.toggleAttribute('data-current', i === clamped);
    });
  }
}

if (!customElements.get('lookbook-carousel')) {
  customElements.define('lookbook-carousel', LookbookCarousel);
}
